<template>
    <transition name="slide">
        <div id="player" :class="{
            desktop: $mq != 'sm',
            mobileOpen: $mq == 'sm' && mobileOpen,
        }">
            <div v-if="mobileOpen && $mq == 'sm'" @click.stop="closeMobile" id="mobileClose">
                <div id="chevron"></div>
            </div>
            <router-link v-if="mobileOpen" :to="{ name: 'detail', params: { id: item.pk } }" @click.native="closeMobile">
                <img :src="item.thumbnail" id="image" :class="{
                    mobileOpen: $mq == 'sm' && mobileOpen,
                }" alt="" />
            </router-link>
            <div id="openWrapper" :class="{
                mobileOpen: $mq == 'sm' && mobileOpen,
            }">
                <div id="playerLeft" @click="openMobile(item.pk)" :class="{
                    desktop: $mq != 'sm',
                    mobileOpen: $mq == 'sm' && mobileOpen,
                    stream:
                        store.privatePlayerItem.type == 'stream' ||
                        store.privatePlayerItem.type == 'playlist',
                }">
                    <img :src="item.thumbnail" id="image" v-if="!mobileOpen" alt="" />
                    <img v-if="store.privatePlayerStatus == 'playing'" @click.stop="store.privatePlayerStatus = 'paused'"
                        id="pause" :src="pauseHover
                            ? '/static/new_icons/pause-player_hover.svg'
                            : '/static/icons/pause-player.svg'
                            " @mouseover="pauseHover = true" @mouseout="pauseHover = false" />
                    <img v-else-if="store.privatePlayerStatus == 'loading'" id="spinner"
                        src="/static/icons/spinner-large.svg" alt="" />
                    <img v-else id="play" @click.stop="unpause" :src="playHover
                        ? '/static/new_icons/play-player-large_hover.svg'
                        : '/static/icons/play-player-large.svg'
                        " @mouseover="playHover = true" @mouseout="playHover = false" />
                    <!-- <div -->
                    <!--     v-if="playerStatus == 'off' || playerStatus == 'paused'" -->
                    <!--     id="text" -->
                    <!-- > -->
                    <!--     <p v-if="$mq == 'sm'" id="artist"> -->
                    <!--         {{ store.privatePlayerItem.artist }} -->
                    <!--     </p> -->
                    <!--     <p v-if="$mq == 'sm'" id="title"> -->
                    <!--         {{ store.privatePlayerItem.title }} -->
                    <!--     </p> -->
                    <!--     <p v-if="$mq != 'sm'" id="artist"> -->
                    <!--         {{ store.privatePlayerItem.artist -->
                    <!--         }}<span -->
                    <!--             v-if=" -->
                    <!--                 store.privatePlayerItem.artist && -->
                    <!--                     store.privatePlayerItem.title -->
                    <!--             " -->
                    <!--             >: </span -->
                    <!--         >{{ store.privatePlayerItem.title }} -->
                    <!--     </p> -->
                    <!-- </div> -->
                    <div id="timelineText" :class="{
                        mobileOpen: mobileOpen,
                        desktop: $mq != 'sm',
                    }">
                        <span id="artist" v-if="store.privatePlayerItem.type == 'stream'">
                            {{ store.privatePlayerItem.title }}
                        </span>
                        <span id="artist" v-else-if="store.privatePlayerItem.type == 'playlist'
                            ">
                            Public Playlist
                        </span>
                        <span id="artist" v-else>
                            {{ item.artist }}
                        </span>
                        <span id="title" v-if="store.privatePlayerItem.type == 'stream' ||
                            store.privatePlayerItem.type == 'playlist'
                            ">
                            Now Playing:
                            <span v-if="item.artist">{{ item.artist }} - </span>{{ item.title }}
                        </span>
                        <span id="title" v-else>
                            {{ item.title }}
                        </span>
                        <span id="location" v-show="mobileOpen &&
                            store.privatePlayerItem.type != 'stream'
                            ">
                            <span id="date">{{ formatDate }}</span>
                            <span v-if="item.venue">{{ item.venue }}</span>
                            <span v-if="item.city">{{ item.city }}</span>
                        </span>
                    </div>
                </div>
                <div id="playerCenter" :class="$mq != 'sm' ? 'desktop' : ''" v-show="store.privatePlayerItem.type != 'playlist' &&
                    store.privatePlayerItem.type != 'stream' &&
                    !jinglePlaying
                    ">
                    <!-- <Teleport -->
                    <!--     :disabled="!mobileOpen && $mq != 'sm'" -->
                    <!--     to="#playerLeft" -->
                    <!-- > -->
                    <span id="past" v-html="past" :class="$mq != 'sm' ? 'desktop' : ''"
                        v-show="$mq != 'sm' || mobileOpen"></span>
                    <div id="barContainer" v-show="$mq != 'sm' || mobileOpen">
                        <!--
            <div id="bar" ref="bar" @mousedown="barMouseDown" @mouseup="barMouseUp">
                <div id="barLine"></div>
                <div id="marker" ref="marker"></div>
            </div>
            -->
                        <input type="range" min="0" max="1000" value="0" ref="progress" id="progress"
                            :class="$mq != 'sm' ? 'desktop' : ''" @change="updateAudio" @mousedown="seeking = true"
                            @mouseup="seeking = false" v-bind:disabled="store.privatePlayerItem.type == 'playlist' ||
                                store.privatePlayerItem.type == 'stream'
                                " />
                    </div>
                    <span id="remaining" v-html="remaining" :class="$mq != 'sm' ? 'desktop' : ''"
                        v-show="$mq != 'sm' || mobileOpen"></span>
                    <!-- </Teleport> -->
                    <!-- @play="playerStatus = 'loading'" -->
                    <!-- @playing="playerStatus = 'playing'" -->
                    <audio ref="audio" :src="source" @timeupdate="callUpdateBar" @loadstart="handleLoad"
                        @playing="handlePlay" @pause="store.privatePlayerStatus = 'paused'" @ended="resetAudio"></audio>
                </div>
            </div>
            <div id="playerRight" :class="$mq != 'sm' ? 'desktop' : ''" v-show="!mobileOpen &&
                store.privatePlayerItem.type != 'playlist' &&
                store.privatePlayerItem.type != 'stream' &&
                !jinglePlaying
                ">
                <div v-show="$mq == 'sm'" id="mobileProgress" ref="mobileProgress"></div>
            </div>

            <!-- <router-link -->
            <!--     :to="{ -->
            <!--         name: 'detail', -->
            <!--         params: { id: store.privatePlayerItem.pk } -->
            <!--     }" -->
            <!-- > -->
            <!--     <img :src="this.item.thumbnail" alt="" /> -->
            <!-- </router-link> -->
        </div>
    </transition>
</template>

<script>
import { store } from "../store";
import _ from "lodash";
import Duration from "luxon/src/duration.js";
import DateTime from "luxon/src/datetime.js";
//import Plyr from 'plyr';

export default {
    name: "PrivatePlayer",
    data() {
        return {
            store: store,
            //position: false,
            // playerStatus: "off",
            allowSeek: false,
            past: "",
            remaining: "",
            seeking: false,
            //plyr: null,
            playHover: false,
            pauseHover: false,
            item: {
                artist: "",
                title: "",
                image: "",
                pk: "",
                duration: 0,
                last_played: 0,
                thumbnail: "",
                start_time: "",
            },
            oldProgress: 0,
            mobileOpen: false,
            source: "",
            jinglePlaying: false,
        };
    },
    watch: {
        "store.privatePlayerStatus"(newVal, oldVal) {
            if (newVal == "paused") {
                this.pause();
            } else if (newVal == "unpaused") {
                let myself = this;
                setTimeout(function () {
                    myself.unpause();
                }, 200);
            }
        },
        "store.privatePlayerItem": {
            handler(newVal, oldVal) {
                if (newVal == oldVal) {
                    this.unpause();
                } else {
                    this.setItem();
                    let myself = this;
                    setTimeout(function () {
                        myself.unpause();
                    }, 200);
                }
            },
            deep: true,
        },
        // "store.streams": {
        //     handler(newVal, oldVal) {
        //         this.setItem();
        //         console.log("set streams");
        //     },
        //     deep: true
        // }
    },
    computed: {
        // getSource() {
        //     console.log("get source");
        //     let source;
        //     if (
        //         this.store.privatePlayerItem.type == "playlist" ||
        //         this.store.privatePlayerItem.type == "stream"
        //     ) {
        //         source =
        //             "https://stream.montezpress.com/icecast/" +
        //             this.store.privatePlayerItem.slug +
        //             "?ts=" +
        //             new Date().getTime();
        //     } else {
        //         // _paq.push([
        //         //     "trackEvent",
        //         //     "Private Player",
        //         //     "Start Listening",
        //         //     store.privatePlayerItem.artist +
        //         //         ": " +
        //         //         store.privatePlayerItem.title
        //         // ]);
        //         if (store.privatePlayerItem.audio) {
        //             source = store.privatePlayerItem.audio;
        //         } else if (store.privatePlayerItem.url) {
        //             source = store.privatePlayerItem.url;
        //         }
        //     }
        //     return source;
        // },
        formatDate() {
            return DateTime.fromISO(this.item.start_time)
                .setLocale("en-US")
                .toFormat("MM/dd/yy");
        },
    },
    methods: {
        setSource() {
            let source;

            if (
                this.store.allowJingle &&
                !this.store.valid &&
                this.store.jingles.length
            ) {
                source =
                    this.store.jingles[
                        Math.floor(Math.random() * this.store.jingles.length)
                    ].audio;
                this.store.allowJingle = false;
                this.jinglePlaying = true;
                //sessionStorage.setItem('jinglePlayed', 'true');
            } else {
                if (
                    this.store.privatePlayerItem.type == "playlist" ||
                    this.store.privatePlayerItem.type == "stream"
                ) {
                    source =
                        "https://stream.montezpress.com/icecast/" +
                        this.store.privatePlayerItem.slug +
                        "?ts=" +
                        new Date().getTime();
                } else {
                    if (store.privatePlayerItem.audio) {
                        source = store.privatePlayerItem.audio;
                    } else if (store.privatePlayerItem.url) {
                        source = store.privatePlayerItem.url;
                    }
                    _paq.push([
                        "trackEvent",
                        "Private Player",
                        "Start Listening",
                        store.privatePlayerItem.artist +
                        ": " +
                        store.privatePlayerItem.title
                    ]);
                }
            }
            this.source = source;
        },
        handlePlay() {
            let myself = this;
            // setTimeout(function() {
            myself.store.privatePlayerStatus = "playing";
            // }, 400);
        },
        handleLoad() {
            this.store.privatePlayerStatus = "loading";
        },
        resetAudio() {
            if (this.jinglePlaying) {
                this.setItem();
                this.jinglePlaying = false;

                let myself = this;
                setTimeout(function () {
                    myself.unpause();
                }, 200);
            } else {
                this.store.privatePlayerStatus = "off";
            }
            this.$refs.audio.currentTime = 0;
            this.updateBar();
        },
        openMobile: function (pk) {
            if (this.$mq == "sm") {
                this.mobileOpen = true;
            } else {
                this.$router.push({ name: "detail", params: { id: pk } });
            }
        },
        closeMobile: function () {
            this.mobileOpen = false;
        },
        unpause: function () {
            this.playHover = false;
            let audio = this.$refs.audio;
            //if (this.store.privatePlayerChanged == true){
            //audio.src = this.store.privatePlayerItem.url
            //this.store.privatePlayerChanged = false;
            //}
            audio.muted = false;
            this.store.publicPlayerStatus = "muted";
            // setTimeout(function() {
            audio.play();
            // }, 500);
            // let promise = audio.play();
            // if (promise) {
            //     promise.then(_ => {
            //         this.playerStatus = "playing";
            //     });
            // }
        },
        //play: function(){
        //this.playerStatus = 'loading'
        //let audio = this.$refs.audio;
        //audio.src = this.store.privatePlayerSource;
        //audio.muted = false;
        //this.store.publicPlayerStatus = 'muted'
        //let promise = audio.play()
        //if (promise) {
        //promise.then(_ => {
        //this.playerStatus = 'playing';
        //})
        //}
        //},
        // pause: function() {
        // this.playerStatus = "paused";
        // let audio = this.$refs.audio;
        // audio.pause();
        // },
        // setUnpause: function() {
        // this.playerStatus = "loading";
        // this.store.privatePlayerStatus = "unpaused";
        // this.unpause();
        // },
        pause: function () {
            // this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
            this.$refs.audio.pause();
            this.store.privatePlayerStatus = "paused";
        },
        easeInOutQuad: function (x) {
            return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
        },
        animateValue: function (progress, difference, percent) {
            let myself = this;
            if (percent < 1) {
                myself.$refs.progress.value =
                    progress + difference * myself.easeInOutQuad(percent);
                percent += 0.05;
                setTimeout(() => {
                    this.animateValue(progress, difference, percent);
                }, 20);
            } else {
                percent = 0;
            }
            // console.log(percent);
        },

        updateBar() {
            let currentTime;
            let duration;
            if (
                this.store.privatePlayerItem.type == "playlist" ||
                this.store.privatePlayerItem.type == "stream"
            ) {
                let iso = this.item.last_played;
                let start = DateTime.fromISO(iso, { zone: "utc" });
                // let end = start.plus({
                //     seconds: this.item.duration
                // });
                currentTime = DateTime.utc().diff(start, "seconds").seconds;
                duration = this.item.duration;
            } else {
                let audio = this.$refs.audio;
                //this.$refs.marker.style.left = 'calc(' + (audio.currentTime / audio.duration) * 100 + '% - 4px)';
                currentTime = audio.currentTime;
                duration = audio.duration;
            }
            if (duration) {
                let newProgress = (currentTime / duration) * 1000;
                if (!this.mobileOpen && this.$mq == "sm") {
                    this.$refs.mobileProgress.style.width =
                        newProgress / 10 + "%";
                } else {
                    this.$refs.progress.value = newProgress;
                }
                // let difference = newProgress - this.oldProgress;
                // this.animateValue(newProgress, difference, 0);
                // this.oldProgress = newProgress;

                let new_duration = Duration.fromMillis(duration * 1000);
                if (new_duration.shiftTo("hours").hours < 1) {
                    this.past = Duration.fromMillis(
                        currentTime * 1000
                    ).toFormat("mm:ss");
                    if (
                        Duration.fromMillis(
                            duration * 1000 - currentTime * 1000
                        ) < 0
                    ) {
                        this.remaining = "-00:00";
                    } else {
                        this.remaining =
                            "-" +
                            Duration.fromMillis(
                                duration * 1000 - currentTime * 1000
                            ).toFormat("mm:ss");
                    }
                } else {
                    this.past = Duration.fromMillis(
                        currentTime * 1000
                    ).toFormat("hh:mm:ss");
                    this.remaining =
                        "-" +
                        Duration.fromMillis(
                            duration * 1000 - currentTime * 1000
                        ).toFormat("hh:mm:ss");
                }
            }
        },
        callUpdateBar: _.throttle(function () {
            if (this.$refs.audio.readyState == 4) {
                this.updateBar();
            }
        }, 500),
        //handleBar(ev){
        //let rect = ev.target.getBoundingClientRect();
        //let x = ev.clientX - rect.left;
        //let perc = x / rect.width;
        //this.$refs.audio.currentTime = perc * this.$refs.audio.duration;
        //},
        barMouseDown(ev) {
            this.allowSeek = true;
            //let audio = this.$refs.audio;
            //audio.pause();
            let rect = this.$refs.bar.getBoundingClientRect();
            let x = ev.clientX - rect.left;
            let perc = x / rect.width;
            this.$refs.audio.currentTime = perc * this.$refs.audio.duration;
        },
        updateAudio() {
            if (
                this.store.privatePlayerItem.type != "playlist" &&
                this.store.privatePlayerItem.type != "stream"
            ) {
                let value = this.$refs.progress.value;
                this.$refs.audio.currentTime =
                    (value / 1000) * this.$refs.audio.duration;
            }
        },
        barMouseUp(ev) {
            this.allowSeek = false;
            //let audio = this.$refs.audio;
            //audio.play();
        },
        barMouseOut(ev) {
            this.allowSeek = false;
            let audio = this.$refs.audio;
            audio.play();
        },
        barMouseMove: _.debounce(function (ev) {
            if (this.allowSeek == true) {
                let rect = this.$refs.bar.getBoundingClientRect();
                let x = ev.clientX - rect.left;
                let perc = x / rect.width;
                this.$refs.audio.currentTime = perc * this.$refs.audio.duration;
            }
        }, 10),
        setItem() {
            if (this.store.privatePlayerItem.type == "stream") {
                let currentTrack = this.store.privatePlayerItem.items.find(
                    (item) => item.playing == true
                );
                let newStream = this.store.streams.find(
                    (stream) => stream.pk == this.store.privatePlayerItem.pk
                );
                let newTrack = newStream.items.find(
                    (item) => item.playing == true
                );
                if (currentTrack.pk != newTrack.pk) {
                    this.item.artist = newTrack.artist;
                    this.item.title = newTrack.title;
                    this.item.image = newTrack.image;
                    this.item.pk = newTrack.pk;
                    this.item.duration = newTrack.duration;
                    this.item.last_played = newTrack.last_played;
                    this.item.thumbnail = newTrack.thumbnail;
                    this.item.start_time = newTrack.start_time;
                    this.item.venue = newTrack.venue;
                    this.item.city = newTrack.city;
                    // this.store.privatePlayerItem = newStream;
                } else {
                    this.item.artist = currentTrack.artist;
                    this.item.title = currentTrack.title;
                    this.item.image = currentTrack.image;
                    this.item.pk = currentTrack.pk;
                    this.item.duration = currentTrack.duration;
                    this.item.last_played = currentTrack.last_played;
                    this.item.thumbnail = currentTrack.thumbnail;
                    this.item.start_time = currentTrack.start_time;
                    this.item.venue = currentTrack.venue;
                    this.item.city = currentTrack.city;
                }
            } else if (this.store.privatePlayerItem.type == "playlist") {
                let currentTrack = this.store.playlist.items.find(
                    (item) => item.playing == true
                );
                this.item.artist = currentTrack.artist;
                this.item.title = currentTrack.title;
                this.item.image = currentTrack.image;
                this.item.pk = currentTrack.pk;
                this.item.duration = currentTrack.duration;
                this.item.last_played = currentTrack.last_played;
                this.item.thumbnail = currentTrack.thumbnail;
                this.item.start_time = currentTrack.start_time;
                this.item.venue = currentTrack.venue;
                this.item.city = currentTrack.city;
            } else {
                this.item.artist = this.store.privatePlayerItem.artist;
                this.item.title = this.store.privatePlayerItem.title;
                this.item.image = this.store.privatePlayerItem.image;
                this.item.pk = this.store.privatePlayerItem.pk;
                this.item.duration = this.store.privatePlayerItem.duration;
                this.item.thumbnail = this.store.privatePlayerItem.thumbnail;
                this.item.start_time = this.store.privatePlayerItem.start_time;
                this.item.venue = this.store.privatePlayerItem.venue;
                this.item.city = this.store.privatePlayerItem.city;
            }

            this.setSource();
            this.$refs.audio.currentTime = 0;
            this.updateBar();
            // this.setUnpause();
        },
    },
    mounted() {
        // this.setItem();
        // let myself = this;
        //this.setUnpause()
        //this.plyr = new Plyr(this.$refs.audio,{
        //controls: ['progress',],
        //}
        //);
        //this.unpause();
        //setTimeout(function(){
        //myself.store.privatePlayerStatus = 'paused';
        //}, 2000)
        //setTimeout(function(){
        //myself.position = true;
        //}, 500)
    },
};
</script>

<style scoped>
#player {
    padding: 1rem 1rem 1rem;
    /* position: fixed; */
    /* border-top: 1px solid black; */
    box-shadow: 0px 0px 10px #00000029;
    width: calc(100vw - 2rem);
    bottom: 0px;
    background-color: white;
    display: flex;
    flex-direction: column;
    font-family: "Montez Small";
    line-height: 1.167rem;
    font-size: 1rem;
    align-items: center;
}

#player.desktop {
    gap: 1rem;
    flex-direction: row;
    font-family: "Montez Large";
    font-size: 1.333rem;
    line-height: 1.667rem;
}

#player.mobileOpen {
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    z-index: 5;
    justify-content: space-between;
    border-top: none;
    box-sizing: border-box;
    position: absolute;
}

.slide-leave-active,
.slide-enter-active {
    transition: bottom 0.5s;
}

.slide-enter {
    bottom: -100px !important;
}

.slide-enter-to {
    bottom: 0px;
}

.slide-leave {
    bottom: 0px;
}

.slide-leave-to {
    bottom: -100px !important;
}

#barContainer {
    position: relative;
    flex-grow: 1;
    display: flex;
}

#bar {
    height: 30px;
    width: 100%;
    cursor: pointer;
}

#barLine {
    position: absolute;
    width: 100%;
    left: 0;
    top: 15px;
    border-top: 1px solid black;
}

#marker {
    position: absolute;
    left: 0;
    top: 10px;
    width: 9px;
    height: 9px;
    border: 1px solid black;
    border-radius: 6px;
    background-color: white;
}

#timeline {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
}

#timeline.desktop {
    width: 75%;
}

#timeline>span {}

#timelineText {
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-size: 12px;
    font-family: "Montez Small";
}

#timelineText.desktop {
    font-size: initial;
    font-family: "Montez Large";
}

#timelineText.mobileOpen {
    font-size: 16px;
    line-height: 1.583rem;
    font-family: "Montez Large";
}

#timelineText.mobileOpen>#location {
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    gap: 1rem;
    margin-top: 3px;
}

img {
    width: 51px;
    height: 51px;
    display: block;
}

img.mobileOpen {
    width: calc(1100vw - 2rem);
    height: calc(1100vw - 2rem);
    margin: 1rem 0;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

#spinner {
    max-width: 3rem;
    animation: spin 1s linear infinite;
}

#text {
    flex-grow: 1;
    min-width: 0;
    /* margin: 0 1rem; */
}

@media only screen and (min-width: 738px) {
    #text {
        /*height: 2.5rem;*/
    }
}

#text p {
    margin: 0;
    min-width: 0;
}

#title,
#artist,
#locationWrapper {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.location {
    /*
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    */
}

.location:first-child {
    margin-right: 1rem;
}

#play,
#pause {
    cursor: pointer;
    height: 3rem;
    width: 3rem;
}

#past,
#remaining {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
    font-size: 12px;
    font-family: "Montez Small";
}

#past.desktop,
#remaining.desktop {}

#progress {
    padding: 0;
    -webkit-appearance: none;
    /* Override default CSS styles */
    appearance: none;
    width: 100%;
    /* Full-width */
    height: 1rem;
    background: white;
    /* Grey background */
    outline: 1px solid black;
    /* Remove outline */
    border-radius: 7px;
    opacity: 1;
    /* Set transparency (for mouse-over effects on hover) */
    border: none;
    cursor: pointer;
    /* Cursor on hover */
}

#progress::-webkit-slider-runnable-track,
#progress::-moz-range-track {
    border-radius: 7px;
}

#mobileProgress {
    height: 1px;
    background-color: black;
    min-width: 2px;
    margin-top: 1rem;
}

#progress::-webkit-slider-thumb {
    -webkit-appearance: none;
    /* Override default look */
    appearance: none;
    width: calc(1rem - 0px);
    /* Set a specific slider handle width */
    height: calc(1rem - 0px);
    /* Set a specific slider handle width */
    background: black;
    /* Green background */
    cursor: pointer;
    /* Cursor on hover */
    border: 1px solid black;
    border-radius: 9px;
}

#progress::-moz-range-thumb {
    width: calc(1rem - 2px);
    /* Set a specific slider handle width */
    height: calc(1rem - 2px);
    /* Set a specific slider handle width */
    background: black;
    /* Green background */
    cursor: pointer;
    /* Cursor on hover */
    border-radius: 9px;
    border-color: black;
}

#playerLeft,
#playerCenter,
#playerRight,
.teleporter {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-direction: row;
    width: 100%;
}

#playerLeft {
    overflow: hidden;
    cursor: pointer;
}

#playerLeft.mobileOpen {}

#playerLeft.mobileOpen>#timelineText {
    flex-grow: 1;
}

#playerRight {
    display: flex;
}

#playerRight.desktop {}

#playerLeft.desktop,
#playerCenter.desktop,
#playerRight.desktop {
    width: 33.33%;
}

#playerLeft.stream {
    width: 100%;
}

#image.mobileOpen {
    width: calc(100vw - 2rem);
    height: calc(100vw - 2rem);
}

#mobileClose {
    align-self: flex-end;
}

#openWrapper {
    display: contents;
}

#openWrapper.mobileOpen {
    display: block;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
}

#chevron {
    position: relative;
    text-align: center;
    padding: 0px;
    margin-bottom: 0px;
    height: 1px;
    width: 27px;
    margin: 1rem 0;
}

#chevron:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: black;
    transform: skew(0deg, 45deg);
}

#chevron:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    background: black;
    transform: skew(0deg, -45deg);
}

#date {
    font-feature-settings: "case" on;
}

/* .delay-enter-active, */
/* .delay-leave-active { */
/*     transition-duration: 0; */
/*     transition-delay: 1s; */
/* } */
</style>
